import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

import DataTable from "react-data-table-component";
import EditIcon from "@mui/icons-material/Edit";

import { getAllRecords, getWarehouseKeyValueList } from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Loader from "../../Common/Loader";
import { getFormattedNumber } from "../../utils/textUtils";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { confirmOrDraftPurchaseOrder } from "../../../services/Purchase/PurchaseService";
import {PURCHASE_URL} from '../../../CONSTANTS';
import PaginationDataTable from '../../Common/PaginationDataTable';
import Select from "react-select"

const PurchaseList = (props) => {
    let navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [wareOptions, setWareOptions] = useState(null)
    const [warehouseId, setWarehouseId] = useState({
        label: "",
        value: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!wareOptions) {
            getWarehouseKeyValueList().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setWareOptions(options);
                    setWarehouseId(options[0]);
                } else {
                    toast(res.message);
                }
            })};
    }, []);


    useEffect(() => {
        const result = data.filter((data) => {
            return (
                data.vendorTitle.toLowerCase().includes(search.toLowerCase()) ||
                data.purchaseOrderNo
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                data.purchaseOrderStatusEnum
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                data.purchaseOrderDate
                    .toLowerCase()
                    .includes(search.toLowerCase())
            );
        });
        setFilteredData(result);
    }, [search]);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo (() =>
        [
            {
                name: "ORDER NO.",
                selector: (data) => data.purchaseOrderNo,
                style: { color: "#007bff",cursor:"pointer" },
            },
            {
                name: "VENDOR NAME",
                style: {cursor:"pointer" },
                selector: (data) => data.vendorTitle,
                width: "300px",
            },
    
            {
                name: "ORDER DATE",
                style: {cursor:"pointer" },
                selector: (data) => data.purchaseOrderDate,
            },
    
            {
                name: "GRN",
                style: {cursor:"pointer" },
                selector: (data) => (
                    <div className='text-center'>
                        {data.isBilled ? (
                            <Tooltip title='Invoiced' arrow placement='top'>
                                <i id='ember591' className='tooltip-container ember-view'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width={512} height={512} viewBox='0 0 512 512' className='icon icon-xxs text-fulfilled'>
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>
                                </i>
                            </Tooltip>
                        ) : data.isConfirm ? (
                            <ReceiptIcon style={{ cursor: 'pointer', align: 'right' }} onClick={() => navigate("/convertbill/" + data.recordId, {state: "bill",})} />
                        ) : (
                            'Not Confirmed'
                        )}
                    </div>
                ),
            },
            {
                name: "PAID",
                style: {cursor:"pointer" },
                selector: (data) => (
                    <div className="text-center">
                        {data.isPaid ? (
                            <Tooltip title="Paid" arrow placement="top">
                                <i
                                    id="ember591"
                                    className="tooltip-container ember-view"
                                >
                                    {" "}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={512}
                                        height={512}
                                        viewBox="0 0 512 512"
                                        className="icon icon-xxs text-fulfilled"
                                    >
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>{" "}
                                </i>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Not Paid" arrow placement="top">
                                <i
                                    id="ember579"
                                    className="tooltip-container ember-view"
                                >
                                    {" "}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={512}
                                        height={512}
                                        viewBox="0 0 512 512"
                                        className="icon icon-xxs fill-empty"
                                    >
                                        <circle cx={256} cy={256} r={256} />
                                    </svg>{" "}
                                </i>
                            </Tooltip>
                        )}
                    </div>
                ),
            },
    
            {
                name: "AMOUNT",
                style: {cursor:"pointer" },
                selector: (data) => getFormattedNumber(data.totalAmount),
            },
    
            {
                name: "ACTION",
                style: {cursor:"pointer" },
                selector: (row) => (
                    <div>
                        {/* {row.isBilled ? ( */}
                        {row.isConfirm ? (
                            <></>
                        ) : (
                            <EditIcon
                                style={{ fontSize: "15px", cursor: "pointer" }}
                                onClick={() => {
                                    navigate("/purchase/" + row.recordId + "/edit");
                                }}
                            />
                        )}
                        &nbsp;&nbsp;
                        {row.isConfirm ? (
                            <></>
                        ) : isLoading ? (
                            <ThumbUpAltIcon
                                style={{
                                    fontSize: '15px',
                                    color: '#94a078',
                                }}
                                // onClick={() => handleConfirm(row.recordId)}
                            />
                        ) : (
                            <ThumbUpAltIcon
                                style={{
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    color: 'greenyellow',
                                }}
                                onClick={() => handleConfirm(row.recordId)}
                            />
                        )}
                    </div>
                ),
            },
        ],[handleRefresh])

    const handleConfirm = (id) => {
        setIsLoading(true);
        confirmOrDraftPurchaseOrder(id).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
                setIsLoading(false);
                handleRefresh();
            } else {
                toast(res.message);
                setIsLoading(false);
            }
        });
    };
    const handleClickNew = () => {
        navigate('/purchase/new');
      };

    const handleRowClick = (row) => {
        let AdditionalInfo={warehouse:warehouseId};
        if (props.onRowClicked) {
          props.onRowClicked(row);
        }      
        const recordId = row.recordId;
        if (recordId) {
          navigate(`/purchase/${recordId}`,{state:AdditionalInfo});
        }
    };

    const handleWarehouseSelect = (e) => {
        setWarehouseId(e);
        handleRefresh();
    }

    return (
        <>
            <div className="page-container">
                <div className="purchase-warehouse mt-2">
                    <Select options={wareOptions} value={warehouseId} onChange={(e) => handleWarehouseSelect(e)} />
                </div>
                <div style={{ height: 500, width: "100%" }}>                  
                    {warehouseId.value !== "" && <PaginationDataTable
                        paginationUrl={PURCHASE_URL() + "getAllRecords"}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        onRowClicked = {handleRowClick}
                        onNewClicked = {handleClickNew}
                        filter={{uuid2 : warehouseId.value}}
                    />}
                </div>
                {isLoading && <Loader />}
            </div>
        </>
    );
};

export default PurchaseList;
